import { Button, Card, Container, Grid } from '@material-ui/core'
import { saveAs } from 'file-saver'
import styled from 'styled-components'
import accountCreationImage from '../../assets/img/help-center/account-creation.jpg'
import contractInspectionImage from '../../assets/img/help-center/contract-inspection.jpg'
import contractProgrammingImage from '../../assets/img/help-center/contract-programming.jpg'
import serviceAgreementAndPaymentImage from '../../assets/img/help-center/service-agreement-payment.jpg'
import AccountCreation from '../../assets/pdf/AccountCreation.pdf'
import ContractInspectionRequest from '../../assets/pdf/ContractInspectionRequest.pdf'
import ContractProgrammingRequest from '../../assets/pdf/ContractProgrammingRequest.pdf'
import ServiceAgreementAndPayment from '../../assets/pdf/ServiceAgreementAndPayment.pdf'
import FormContainer from '../Form/FormContainer'

const HelpCenterGridContainer = styled(Grid)`
  .MuiCard-root {
    position: relative;

    .content {
      position: absolute;
      bottom: 32px;
      left: 32px;
      color: white;
    }
  }
`

interface Props {
  img: string
  file: File
  name: string
  header: string
  subheader: string
}

const HelpCenter = () => {
  const PDFCard = ({ img, file, name, header, subheader }: Props) => {
    return (
      <HelpCenterGridContainer item md={6} sm={12}>
        <Card>
          <img src={img} alt="Contract Inspection Request" />

          <div className="content">
            <div className="fs18 strong m-b-8">{header}</div>
            <div className="fs16">{subheader}</div>
            <Button
              variant="outlined"
              className="btn-white m-t-32"
              onClick={() => saveAs(file, name)}
            >
              Download
            </Button>
          </div>
        </Card>
      </HelpCenterGridContainer>
    )
  }

  return (
    <Container className="help-center">
      <FormContainer>
        <h3 className="page-title">Help center</h3>

        <Grid container spacing={4}>
          <PDFCard
            img={accountCreationImage}
            file={AccountCreation}
            name="MyQuality Account Creation"
            header="Account creation"
            subheader="Get help setting up your account"
          />
          <PDFCard
            img={contractProgrammingImage}
            file={ContractProgrammingRequest}
            name="MyQuality Contract Programming Request"
            header="Contract programming request"
            subheader="Learn how to create a programming request"
          />
          <PDFCard
            img={contractInspectionImage}
            file={ContractInspectionRequest}
            name="MyQuality Contract Inspection Request"
            header="Contract inspection request"
            subheader="Learn how to create a contract inspection request"
          />
          <PDFCard
            img={serviceAgreementAndPaymentImage}
            file={ServiceAgreementAndPayment}
            name="MyQuality Account Creation"
            header="Service agreement & payment"
            subheader="Get help with service agreements and payment "
          />
        </Grid>
      </FormContainer>
    </Container>
  )
}

export default HelpCenter
